import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import DragML from '../DragML/DragML';
import DragContentML from '../DragContentML/DragContentML';
import GoodsShelfContentStyles from './GoodsShelfContentStyles';

export default () => {
  const [num, setNum] = useState(0);
  return (
    <GoodsShelfContentStyles>
      <Box height="100%">
        <Box
          sx={{
            color: '#212121',
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '18px',
          }}
        >
          货架内容设定
        </Box>
        <Box className="control-wrap">
          <Box>
            <DragML num={num} setNum={setNum} />
          </Box>
          <Box sx={{ padding: '15px 16px' }}>
            <DragContentML num={num} setNum={setNum} />
          </Box>
        </Box>
      </Box>
    </GoodsShelfContentStyles>
  );
};
